/* eslint-disable no-unused-vars */
import { Box, Collapse } from '@chakra-ui/react';
import {
    KoddiLocaleKey,
    KODDI_LOCALE_TO_DATEFNS,
} from 'app/koddi-components/src/LocaleProvider';
import { format } from 'date-fns';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
// eslint-disable-next-line import/no-cycle
import { CustomDatePickerInput } from '../atoms';
import { CFormError } from '../../../../Typography';
import { BaseDatePickerProps } from '../DatePicker.types';
import { useSingleDatePicker } from './SingleDatePicker.hooks';
import { DatePickerStyled } from './SingleDatePicker.styled';

Object.keys(KODDI_LOCALE_TO_DATEFNS).forEach((localeKey) => {
    registerLocale(
        localeKey,
        KODDI_LOCALE_TO_DATEFNS[localeKey as KoddiLocaleKey]
    );
});

export const CSingleDatePicker = ({
    testId,
    name,
    errorText,
    hideError,
    inputValue,
    onChange,
    locale,
    disabled = false,
    onBlur,
    showIcon,
    ...props
}: BaseDatePickerProps): JSX.Element => {
    const {
        date,
        handleChangeRaw,
        handleChange,
        refCustomInput,
    } = useSingleDatePicker({ inputValue, onChange });

    return (
        <Box minWidth="150px" width="100%">
            <DatePickerStyled>
                <ReactDatePicker
                    renderDayContents={(dayOfMonth, dayDate) => (
                        <span
                            data-test={
                                dayDate ? format(dayDate, 'MM/dd/yyyy') : ''
                            }
                        >
                            {dayOfMonth}
                        </span>
                    )}
                    locale={locale}
                    selected={date}
                    onChangeRaw={(e) => handleChangeRaw(e)}
                    onChange={(v: Date | null) => handleChange(v)}
                    popperPlacement="bottom-end"
                    customInput={
                        // eslint-disable-next-line react/jsx-wrap-multilines
                        <CustomDatePickerInput
                            name={name}
                            hasError={!!errorText}
                            ref={refCustomInput}
                            disabled={disabled}
                            showIcon={showIcon}
                        />
                    }
                    closeOnScroll={(e) => e.target === document}
                    name={name}
                    id={name}
                    data-test={`${testId}--date-picker`}
                    disabled={disabled}
                    onCalendarClose={onBlur}
                    {...props}
                />
                <Collapse in={!hideError}>
                    <CFormError
                        data-test={`${testId}--error`}
                        text={errorText}
                    />
                </Collapse>
            </DatePickerStyled>
        </Box>
    );
};
